import { z } from 'zod';
import { TextItem } from './common';
export var CopingStrategy = TextItem;
export var CopingStrategies = z.array(CopingStrategy).prefault([]);
